"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const hooks_1 = require("preact/hooks");
const filter_1 = require("../lib/filter");
function useFilter(items, taxonomies) {
    const [selection, update] = useFilterState(taxonomies);
    const filteredItems = (0, hooks_1.useMemo)(() => (0, filter_1.filterItems)(items, selection), [items, selection]);
    const isSelected = useSelectedCallback(selection);
    // const isEnabled = useEnabledCallback(filteredItems, taxonomies);
    const handleInput = (0, hooks_1.useCallback)(({ target }) => {
        if (target instanceof HTMLSelectElement || target instanceof HTMLInputElement) {
            update(target.name, target.value);
        }
    }, [update]);
    return {
        items: filteredItems,
        selection,
        update,
        isSelected,
        handleInput,
        // isEnabled,
    };
}
exports.default = useFilter;
function useFilterState(taxonomies) {
    const [selection, setSelection] = (0, hooks_1.useState)(() => {
        const filters = {};
        for (const taxonomy of taxonomies) {
            filters[taxonomy.slug] = null;
        }
        return filters;
    });
    const update = (0, hooks_1.useCallback)((taxonomy, term) => {
        setSelection((selected) => (Object.assign(Object.assign({}, selected), { [taxonomy]: term === '' ? null : term })));
    }, [setSelection]);
    return [selection, update];
}
function useSelectedCallback(filters) {
    return (0, hooks_1.useCallback)((taxonomy, term) => {
        return filters[taxonomy] === term;
    }, [filters]);
}
function useEnabledCallback(items, taxonomies) {
    const options = (0, hooks_1.useMemo)(() => {
        const options = {};
        for (const taxonomy of taxonomies) {
            options[taxonomy.slug] = taxonomy.terms.filter((term) => {
                return items.some((item) => {
                    return item.terms[taxonomy.slug].includes(term.slug);
                });
            }).map((term) => {
                return term.slug;
            });
        }
        return options;
    }, [items, taxonomies]);
    return (0, hooks_1.useCallback)((taxonomy, term) => {
        var _a, _b;
        return (_b = (_a = options[taxonomy]) === null || _a === void 0 ? void 0 : _a.includes(term)) !== null && _b !== void 0 ? _b : false;
    }, [options]);
}
